import { render, staticRenderFns } from "./IconNotify.vue?vue&type=template&id=10f1f735&scoped=true"
import script from "./IconNotify.vue?vue&type=script&setup=true&lang=js"
export * from "./IconNotify.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f1f735",
  null
  
)

export default component.exports